import {IRouteOnBoardState,IRouteOnBoardActionTypes,IRouteOnBoardActionCreator} from 'models/IRouteBookingState';

const initialState:{data:IRouteOnBoardState[]} = {data:[]}

const reducer = (state = initialState, { type, payload }: IRouteOnBoardActionCreator) => {
    switch (type) {
      case IRouteOnBoardActionTypes.FETCH_ROUTES_LIST_FAILURE:
        return {
          ...state,
          data:[],
        }
      case IRouteOnBoardActionTypes.FETCH_ROUTES_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;